import {basicActions, getUpdatedLocalizations, setAppLoadingState} from './actions'
import {basicSelectors, someCoolSelector} from './selectors'

export const GlobalService = {
  actions: {...basicActions, setAppLoadingState, getUpdatedLocalizations},
  selectors: {...basicSelectors, someCoolSelector},
} as const
